import React, { Component } from "react";
import { styled } from "@mui/material/styles";
import apm from "shared/utils/apm";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: localStorage.getItem("theme") || "dark",
  },
});

const Root = styled("div")({
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
});

class ErrorMonitoring extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });

    apm.captureError(error);

    console.log("ErrorMonitoring", { error, errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Root>
              <Grid
                container
                spacing={4}
                alignItems="center"
                justifyContent="space-between"
                style={{ maxWidth: 480 }}
              >
                <Grid size={12}>
                  <Typography variant="h4" align="center" color="textPrimary">
                    Something went wrong
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography
                    variant="subtitle1"
                    align="center"
                    color="textSecondary"
                  >
                    The developers received a message about this error and
                    promise fix everything soon.
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Button
                    //   fullWidth
                    disableElevation
                    color="primary"
                    variant="contained"
                    size="large"
                    onClick={() => {
                      document.location.reload();
                    }}
                  >
                    Reload page
                  </Button>
                </Grid>
              </Grid>
            </Root>
          </ThemeProvider>
        </StyledEngineProvider>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorMonitoring;
